"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableHeaderCell = void 0;
var react_1 = __importDefault(require("react"));
var AcTable_module_scss_1 = __importDefault(require("./AcTable.module.scss"));
var AcTableHeaderCellTitle_1 = require("./AcTableHeaderCellTitle");
var interfaces_1 = require("./interfaces");
var AcTableHeaderCell = function (props) {
    var column = props.column, columnIndex = props.columnIndex, sortFieldName = props.sortFieldName, sortDirection = props.sortDirection, functionContext = props.functionContext;
    var data = column.data, name = column.name, title = column.title, headerClassName = column.headerClassName, sortable = column.sortable, freezeColumn = column.freezeColumn;
    var createTitle = function () {
        if (typeof title === 'function') {
            return title(functionContext);
        }
        if (typeof title === 'string') {
            return title;
        }
        if (title) {
            return title;
        }
        if (typeof name === 'string') {
            return name;
        }
        return data;
    };
    var buildSortable = function () {
        if (typeof sortable === 'function') {
            return sortable(functionContext);
        }
        return sortable;
    };
    var onSortInternal = function (columnId, _sortDirection) {
        if (column.onSort) {
            column.onSort(columnId, _sortDirection);
        }
        else if (props.onSort) {
            props.onSort(columnId, _sortDirection);
        }
    };
    var renderTitle = function () {
        var titles = [];
        if (Array.isArray(name)) {
            name.forEach(function (n, index) {
                var sorted = sortFieldName === n && [interfaces_1.SORT_ASC, interfaces_1.SORT_DESC].includes(sortDirection);
                var titleValue = createTitle();
                if (Array.isArray(titleValue)) {
                    titleValue = titleValue[index];
                }
                titles.push(react_1.default.createElement(AcTableHeaderCellTitle_1.AcTableHeaderCellTitle, { sortable: buildSortable(), sorted: sorted, sortFieldName: sortFieldName, sortDirection: sortDirection, name: n, title: titleValue, columnIndex: columnIndex, onSort: onSortInternal, key: index + "-" + n }));
                if (index < name.length - 1) {
                    titles.push(react_1.default.createElement("span", { key: index + "-" + n + "_slash", className: "mr-1" }, "/"));
                }
            });
        }
        else {
            var sorted = [interfaces_1.SORT_ASC, interfaces_1.SORT_DESC].includes(sortDirection);
            titles.push(react_1.default.createElement(AcTableHeaderCellTitle_1.AcTableHeaderCellTitle, { sortable: buildSortable(), sorted: sorted, sortFieldName: sortFieldName, sortDirection: sortDirection, name: name, title: createTitle(), columnIndex: columnIndex, onSort: onSortInternal, key: "" + name }));
        }
        return titles;
    };
    var buildHeaderClassname = function () {
        var value = '';
        if (typeof column.headerClassName === 'function') {
            value = column.headerClassName(functionContext);
        }
        else if (column.headerClassName) {
            value = column.headerClassName;
        }
        return value;
    };
    return (react_1.default.createElement("th", { className: buildHeaderClassname() + " \n      " + (freezeColumn && AcTable_module_scss_1.default.freezeColumnHeader) + " text-nowrap text-primary" },
        react_1.default.createElement("div", null, renderTitle())));
};
exports.AcTableHeaderCell = AcTableHeaderCell;
exports.AcTableHeaderCell.displayName = 'AcTableHeaderCell';
//# sourceMappingURL=AcTableHeaderCell.js.map